const quoteCreationTypeOptions = [
  {
    label: "Firm",
    value: "Firm",
  },
  {
    label: "Budgetary",
    value: "Budgetary",
  },
];
export default quoteCreationTypeOptions;
